import { lazy, StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router";
import "./index.css";
import { AuthProvider } from "./context/AuthContext.tsx";
import { PrivateRoute } from "./components/auth/PrivateRoute.tsx";
import { PERMISOS } from "./constants/permissions.ts";
import { Toaster } from "./components/ui/sonner";
import { MasterDataLayout } from "./components/master-data/MasterDataLayout.tsx";

const Home = lazy(() => import("./pages/Home.tsx"));
const LoginPage = lazy(() => import("./pages/Login.tsx"));
const DeceasedPatientsPage = lazy(() => import("./features/deceased-patients/pages/DeceasedPatientsPage.tsx"));

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          <Route
            path="/"
            element={
              <PrivateRoute>
                <MasterDataLayout>
                  <Home />
                </MasterDataLayout>
              </PrivateRoute>
            }
          >
            <Route
              index
              element={
                <PrivateRoute
                  requiredPermission={PERMISOS.FALLECIDOS.VER_CARGA_ARCHIVO}
                >
                  <DeceasedPatientsPage />
                </PrivateRoute>
              }
            />
            <Route
              path="deceased-patients"
              element={
                <PrivateRoute
                  requiredPermission={PERMISOS.FALLECIDOS.VER_CARGA_ARCHIVO}
                >
                  <DeceasedPatientsPage />
                </PrivateRoute>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster />
    </AuthProvider>
  </StrictMode>,
);
